import {Typed} from "app/stimulus/typed-stimulus";
import {Controller} from "@hotwired/stimulus";
import {AsStimulusController} from "app/stimulus/as-stimulus-controller";
import {LiveComponentAwareController} from "app/stimulus/live-component-aware-controller";
import {Component} from "@symfony/ux-live-component";
import {componentsLoader} from "app/service/components-loader";

@AsStimulusController('crm-person-detail-api3-credentials-form')
export default class extends Typed(
    LiveComponentAwareController(Controller<HTMLElement>), {
        targets: {
            isSendCredentials: HTMLInputElement,
            sendToEmailRow: HTMLElement,
            sendToPhoneRow: HTMLElement,
            sendCredentialsLocaleRow: HTMLElement,
            pdfPasswordContainer: HTMLElement,
        }
    }
) {
    declare private onComponentRenderFinished: () => void;

    public initialize(): void {
        this.onComponentRenderFinished = this.initJs.bind(this);
    }

    public connect(): void {
        this.setupLayout();
        this.initJs();
    }

    public liveComponentConnect(component: Component) {
        component.on('render:finished', this.onComponentRenderFinished);
    }

    public liveComponentDisconnect(component: Component) {
        component.off('render:finished', this.onComponentRenderFinished);
    }

    public onIsSendCredentialsChange(): void {
        this.setupLayout();
    }

    private setupLayout(): void {
        if (this.hasIsSendCredentialsTarget) {
            const isChecked = this.isSendCredentialsTarget.checked;
            if (isChecked) {
                this.sendToEmailRowTarget.style.display = '';
                this.sendToPhoneRowTarget.style.display = '';
                this.pdfPasswordContainerTarget.style.display = '';
                this.sendCredentialsLocaleRowTarget.style.display = '';
                return;
            }
            this.sendToEmailRowTarget.style.display = 'none';
            this.sendToPhoneRowTarget.style.display = 'none';
            this.pdfPasswordContainerTarget.style.display = 'none';
            this.sendCredentialsLocaleRowTarget.style.display = 'none';
        }
    }

    private initJs(): void {
        componentsLoader.load(this.element);
    }
}
